<template>
    <div class="configuration-workspaces-container">
        <workspaces-list 
            :workspaces="allWorkspaces" 
            :selected-workspace="getSelectedWorkspace" 
            @set-selected-workspace="setSelectedWorkspace" 
            :isLoading="isLoading"
        />
        <v-card class="workspace-card-container">
            <h3 class="workspace-title">Map</h3>
            <div class="workspace-container">
                <workspace-map
                    ref="workspaceMap"
                    :polygon="getSelectedPolygon"
                    :workspace="getSelectedWorkspace"
                    :draw-polygon="true"
                    :view-all-workspaces="false"
                    :is-npv="true"
                    @clear-selected-workspace="clearSelectedWorkspace"
                    @feature-wkt="polygonGeomatry"
                />
            </div>
        </v-card>
    </div>
</template>
  
<script>
    import { mapActions } from "vuex";
    import WorkspacesList from "../components/WorkspacesList.vue";
    import WorkspaceMap from '@/components/ProjectManagement/Workspaces/WorkspaceMap'
    import { configurationsMixin } from "@/mixins/npv/configurationsMixin";
    export default {
        name: "ConfigurationWorkspaces",
        components: {
            WorkspacesList,
            WorkspaceMap
        },
        mixins: [configurationsMixin],
        data(){
            return {
                allWorkspaces: [],
                isLoading: false
            }
        },
        computed: {
            getSelectedWorkspace(){
                return this.$store.getters.getWorkspace
            },
            getSelectedPolygon(){
                let polygon;
                if(!this.$store.getters.getWorkspace && this.$store.getters.getWorkspaceGeometry){
                    polygon = this.convertToGeoJSON(this.$store.getters.getWorkspaceGeometry);
                }
                return polygon;
            }
        },
        mounted() {
            this.getWorkspaces();
        },
    
        methods: {
            ...mapActions(["setProvisionalWorkspace","fetchAllWorkspaces", "setProjection", "setWorkspaceGeomatry", "setWorkspace", "clearWorkspace", "clearWorkspaceGeometry", "clearBuildings"]),

            async getWorkspaces() {
                try{
                    this.isLoading = true;
                    this.allWorkspaces = await this.fetchAllWorkspaces({fields: null, includes: null});
                    if(this.allWorkspaces.length){
                        this.setProvisionalWorkspace(this.allWorkspaces[0].wp_id);
                    }
                }catch(err){
                    console.log(err)
                }finally{
                    this.isLoading = false;
                }
            },
            setSelectedWorkspace(workspace){
                this.setWorkspace(workspace)
                this.setWorkspaceGeomatry(workspace.wp_text_geom);
                this.setProjection(4326);
                if(this.$store.getters.getSelectedBuildings.length > 0){
                    this.clearBuildings();
                }
            },
            clearSelectedWorkspace(isDrawing){
                if(isDrawing){
                    this.clearWorkspace();
                    this.clearWorkspaceGeometry();
                    if(this.$store.getters.getSelectedBuildings.length > 0){
                        this.clearBuildings();
                    }
                }
            },
            polygonGeomatry(value) {
                this.setWorkspaceGeomatry(value);
                this.setProjection(3857);
            },
            getProjection() {
                const projection = this.$refs.workspaceMap.getProjection()
                return projection
            }
        }
    };
</script>
<style scoped>
  .configuration-workspaces-container{
    width: 100%;
    height: calc(100% - 110px);
    display: flex;
  }
  .workspace-card-container{
    width: 88%;
    height: 100%;
    margin-top: 15px;
    margin-left: 10px;
    padding: 0px 40px 40px 40px;
  }
  .workspace-title{
    padding-top: 20px;
    text-align: left;
    color: #4fa2b7;
    padding-bottom: 25px;
  }
  .workspace-container{
    width: 100%;
    height: calc(100% - 70px);
  }
</style>
  


// WEBPACK FOOTER //
// src/components/Npv/Configuration/views/ConfigurationWorkspaces.vue